import { useNavigate, useLocation } from 'react-router-dom'
import { CABINET_PATH, hasCabinetReturnFlag } from '../lib/cabinetReturn'
import './CabinetReturnBar.css'

/**
 * Globální návrat do Můj kabinet při deep-linku z Přehledu.
 * Nezávislé na lokálních tlačítkách „Zpět“ v modulech.
 */
export function CabinetReturnBar() {
  const navigate = useNavigate()
  const location = useLocation()

  if (location.pathname === CABINET_PATH) return null
  if (!hasCabinetReturnFlag(location.search)) return null

  return (
    <div className="cabinet-return-bar" role="navigation" aria-label="Návrat do Můj kabinet">
      <button
        type="button"
        className="cabinet-return-bar__btn"
        onClick={() => navigate(CABINET_PATH)}
      >
        ← Můj kabinet
      </button>
      <span className="cabinet-return-bar__hint">Zpět na přehled žádostí</span>
    </div>
  )
}
